import {
    CHANGE_DATES,
    CHANGE_INTERVAL
} from '../../common/actions/types/datepicker-action-types';
import {
    CHANGE_DOMAIN_TYPE,
    DOMAIN_CLEARED,
    DOMAIN_SELECTED
} from '../../common/actions/types/domain-selector-action-types';
import {
    CHANGE_DMARC_PASS_TYPE
} from '../../common/actions/types/domain-portfolio-dmarc-selector-action-types';
import { SWITCH_REPORT_TABS } from '../../common/actions/types/ui-state-action-types';
import {
    PREVIOUS_7_DAYS,
    PREVIOUS_30_DAYS,
} from '../../common/constants/definitions';
import { combineReducers } from 'redux';
import { dateOptionMap } from '../../common/constants/date-options';
import { getQueryParams } from '../../utils/query-param-utils';
import moment from 'moment';

let initialDateRange = {
    end: moment().utc().subtract( 1,'d' ).format( 'YYYY-MM-DD' ),
    option: PREVIOUS_30_DAYS,
    start: moment().utc().subtract( 30,'d' ).format( 'YYYY-MM-DD' ),
};
let initialInterval = 'day';
let initialDomain = '';
let initialDomainType = 'all';

const { interval, dateRange, domain, domainType } = getQueryParams();

if( interval ){
    initialInterval = interval;
}
if( dateRange ){
    const { key: option, start, end } = dateOptionMap[dateRange];
    initialDateRange = {
        end,
        option,
        start,
    };
}

if( domain ){
    initialDomain = domain;
}
if( domainType ){
    initialDomainType = domainType;
}

function initializeDateRange( report, currentDateRange ){
    let resultingDateRange;
    if( ( report === 'domain-portfolio' && currentDateRange.option !== PREVIOUS_30_DAYS && currentDateRange.option !== PREVIOUS_7_DAYS )
        ||  ( report !== 'domain-portfolio' && currentDateRange.option === PREVIOUS_7_DAYS ) ){
        // This accounts for incompatible date ranges between the reports
        resultingDateRange = {
            end: moment().utc().subtract( 1,'d' ).format( 'YYYY-MM-DD' ),
            option: PREVIOUS_30_DAYS,
            start: moment().utc().subtract( 30,'d' ).format( 'YYYY-MM-DD' ),
        };
    }
    else{
        resultingDateRange = currentDateRange;
    }
    return resultingDateRange;
}

function selectedDateRange( state = initialDateRange, action ){
    let newState = {};
    switch( action.type ){
        case CHANGE_DATES:
            if( action.namespace === 'reports' ){
                newState.option = action.option;
                newState.start = moment( action.start ).utc().format( 'YYYY-MM-DD' );
                newState.end = moment( action.end ).utc().format( 'YYYY-MM-DD' );
            }
            else{
                return state;
            }
            break;
        case SWITCH_REPORT_TABS:
            newState = initializeDateRange( action.selectedTabName, state );
            break;
        default:
            return state;
    }

    return newState;
}

function selectedInterval( state = initialInterval, action ){
    let newState = '';
    switch( action.type ){
        case CHANGE_INTERVAL:
            if( action.namespace === 'reports' ){
                newState = action.interval;
            }
            else{
                return state;
            }
            break;
        case SWITCH_REPORT_TABS:
            if( action.selectedTabName === 'domain-portfolio' ){
                newState = initialInterval;
            }
            else{
                return state;
            }
            break;
        default:
            return state;
    }

    return newState;
}

function selectedDomain( state = initialDomain, action ){
    let newState = '';

    switch( action.type ){
        case DOMAIN_SELECTED:
            if( action.namespace === 'reports' ){
                newState = action.domain;
            }
            else{
                return state;
            }
            break;
        case DOMAIN_CLEARED:
            if( action.namespace === 'reports' ){
                newState = '';
            }
            else{
                return state;
            }
            break;
        default:
            return state;
    }

    return newState;
}

function selectedDomainType( state = initialDomainType, action ){
    let newState = '';

    switch( action.type ){
        case CHANGE_DOMAIN_TYPE:
            if( action.namespace === 'reports' ){
                newState = action.domainType;
            }
            else{
                return state;
            }
            break;
        default:
            return state;
    }

    return newState;
}

function selectedDmarcPassType( state = 'single', action ){
    let newState = '';

    switch( action.type ){
        case CHANGE_DMARC_PASS_TYPE:
            newState = action.dmarcPassType;
            break;
        default:
            return state;
    }

    return newState;
}


export default combineReducers( {
    selectedDateRange,
    selectedDmarcPassType,
    selectedDomain,
    selectedDomainType,
    selectedInterval,
} );
